<script>
  import IconBadge from "@/core/components/badges/IconBadge"
  import ResponsiveTable from "@/core/components/table/ResponsiveTable"

  export default {
    components: {
      ResponsiveTable,
      IconBadge,
    },
    props: {
      search: {
        closed: {
          type: Boolean,
          default: false,
        },
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        headers: ["Nome", "CNPJ", "Perfis", "Situação", ""],
        page: 1,
        pagination: {},
        links: [],
      }
    },
    mounted() {
      this.getLinks()
    },
    methods: {
      getLinks() {
        this.$Progress.start()
        this.loading = true
        this.$axios
          .post(`/api/registry/person/organizations?page=${this.page}`, {
            search: this.search,
            orderBy: {
              id: "DESC",
            },
          })
          .then((resp) => {
            this.links = resp.data.data
            this.pagination = resp.data
            this.pagination.data = undefined
            this.loading = false
            this.$Progress.finish()
          })
          .catch(() => {
            this.links = []
            this.loading = false
            this.$Progress.finish()
          })
      },
      changePage(page) {
        if (page !== this.page) {
          this.page = page
          this.getLinks()
        }
      },
      dataMap(data) {
        if (data.length > 0) {
          return data.map((item) => ({
            name: item.name,
            document: item.document_formatted,
            profiles: item.links.length ? item.links[0].profiles : [],
            status: item.links.length ? item.links[0].condition : null,
          }))
        }
        return []
      },
    },
  }
</script>
<template>
  <ResponsiveTable
    :headers="headers"
    :data="dataMap(links)"
    :pagination="pagination"
    :disabled="loading"
    @changePage="page => changePage(page)"
  >
    <template #row="props">
      <td :class="props.tdClass">{{ props.row.name }}</td>
      <td :class="props.tdClass">{{ props.row.document }}</td>
      <td :class="props.tdClass">
        <div v-if="props.row.profiles.length" class="flex flex-wrap">
          <span
            v-for="profile in props.row.profiles"
            v-bind:key="profile.id"
            class="bg-green-100 border border-teal-700 text-teal-700 font-medium p-1 rounded text-xs mr-1 mb-1"
          >
            {{ profile.name }}
          </span>
        </div>
        <span
          v-else
          class="bg-red-100 border border-red-base text-red-base font-medium p-1 rounded text-xs"
        >
          Nenhum perfil
        </span>
      </td>
      <td :class="props.tdClass">
        <div v-if="props.row.status">
          <IconBadge :text="props.row.status.name"/>
        </div>
        <div v-else>Não vinculado</div>
      </td>
    </template>
    <template #responsive="props">
      <tr class="p-2">
        <th :class="props.thClass">CNPJ</th>
        <td :class="props.tdClass">{{ props.row.document }}</td>
      </tr>
      <tr class="p-2">
        <th :class="props.thClass">Perfis</th>
        <td :class="props.tdClass">
          <div v-if="props.row.profiles.length" class="flex flex-wrap">
            <span
              v-for="profile in props.row.profiles"
              v-bind:key="profile.id"
              class="bg-green-100 border border-teal-700 text-teal-700 font-medium p-1 rounded text-xs mr-1 mb-1"
            >
              {{ profile.name }}
            </span>
          </div>
          <span
            v-else
            class="bg-red-100 border border-red-base text-red-base font-medium p-1 rounded text-xs"
          >
            Nenhum perfil
          </span>
        </td>
      </tr>
      <tr class="p-2">
        <th :class="props.thClass">Situação</th>
        <td :class="props.tdClass">
          <div v-if="props.row.status">
            <IconBadge :text="props.row.status.name"/>
          </div>
          <div v-else>Não vinculado</div>
        </td>
      </tr>
    </template>
  </ResponsiveTable>
</template>
